
export default function Services() {
  const services = [
    {
      icon: 'ri-settings-3-line',
      title: 'Tire Installation',
      description: 'Professional tire mounting and balancing services with state-of-the-art equipment for perfect installation every time.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Tire Repair',
      description: 'Expert tire repair services including puncture fixes, patch work, and comprehensive tire maintenance to extend tire life.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Tire Rotation',
      description: 'Regular tire rotation services to ensure even wear and maximize the lifespan of your tires for optimal performance.'
    },
    {
      icon: 'ri-align-center',
      title: 'Wheel Alignment',
      description: 'Precision wheel alignment services to improve handling, reduce tire wear, and enhance your vehicle safety and fuel efficiency.'
    },
    {
      icon: 'ri-contrast-2-line',
      title: 'Tire Balancing',
      description: 'Advanced tire balancing to eliminate vibrations, ensure smooth rides, and prevent uneven tire wear for better performance.'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Free Inspection',
      description: 'Complimentary tire inspection services to check tread depth, air pressure, and overall tire condition for your safety.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-zinc-900 mb-4">
            Our Expert Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive tire services from installation to maintenance, delivered by certified technicians at Seneca Tire Shop
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mb-6">
                <i className={`${service.icon} text-3xl text-red-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-zinc-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
